export default __webpack_public_path__ + "static/media/1340.af9b421d.png";